<template>
    <a-modal :title="title" v-dragModal :width="1000" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false" :body-style="{height: '480px',overflow: 'hidden',overflowY: 'scroll'}" :labelCol="labelCol" :wrapperCol="wrapperCol" @ok="handleOk" @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')">
        <a-spin :spinning="confirmLoading">
            <bpmn-modeler ref="refNode" :xml="xmlData" :users="users" :groups="groups" :categorys="categorys" :is-view="xmlView" @save="save" />
        </a-spin>
    </a-modal>
</template>

<script>
// import bpmnModeler from "workflow-bpmn-modeler-antdv";
import bpmnModeler from "workflow-bpmn-modeler";
import {
  categoryList,
  delDeployment,
  listDefinition,
  readXml,
  roleList,
  saveXml,
  updateState,
  userList
} from "@views/flowable/api/definition";
export default {
    components: {
        bpmnModeler,
    },
    data() {
        return {
            title: this.$t('操作'),
            buttonStyle: 'solid',
            visible: false,
            model: {},
            categorys: [],
            fileList: [],
            confirmLoading: false,
            url: {
                add: "/jeecg-engineering/sample/vSampleStandard/add",
                edit: "/jeecg-engineering/sample/vSampleStandard/edit",
            },
        }
    },
    computed: {
        validatorRules() {
            return {
                standardName: [
                    { required: true, message: this.$t('请输入标准名称!') },
                ],
                standardNumber: [
                    { required: true, message: this.$t('请输入标准编码!') },
                ],
                useStatus: [
                    { required: true, message: this.$t('请选择使用状态!') },
                ],
            }
        }
    },
    created() {
    },
    methods: {
        add(record) {
            // 统一设置默认值
            this.edit(record)
        },
        edit(record) {
            this.visible = true;
            console.log("编辑返回", record);
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.model = Object.assign({}, record)
            })
        },
        close() {
            this.$emit('close');
            this.model = this.$options.data.call(this).model
            this.fileList = this.$options.data.call(this).fileList
            this.disableSubmit = false;
            this.visible = false;
        },
        handleOk() {
            const that = this;
            // 触发表单验证
            this.$refs.form.validate((ok, err) => {
                if (ok) {
                    that.confirmLoading = true;
                    let httpurl = '';
                    let method = '';
                    if (!this.model.id) {
                        httpurl += this.url.add;
                        method = 'post';
                    } else {
                        httpurl += this.url.edit;
                        method = 'put';
                    }
                    const { fileList } = this;
                    let formData = new FormData();
                    formData = paramsToFormData(filterObj(this.model));
                    fileList.forEach((file) => {
                        formData.append('file', file);
                    });
                    console.log('提交参数', formData)
                    uploadAction(httpurl, formData).then((res) => {
                        if (res.success) {
                            that.$message.success(res.message);
                            that.$emit('ok');
                            that.close();
                        } else {
                            that.$message.warning(res.message);
                        }
                    }).finally(() => {
                        that.confirmLoading = false;
                    })

                }
            })
        },
        handleCancel() {
            this.close()
        },
        //上传文件
        beforeUpload(file) {
            // 只支持Excel,
            let fileName = file.name;
            let fileType = fileName.substring(fileName.lastIndexOf("."), fileName.length);
            console.log(fileType)
            if (fileType != '.xls') {
                //this.$message.error("只支持.xls格式文件！")
                return false;
            } else {
                this.fileList = [file];
                this.model.fjName = this.fileList[0].name;
                return false;
            }
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        }

    }
}
</script>

<style scoped>
/deep/ .ant-checkbox-group {
    height: 32px;
}
/deep/ .ant-model-content {
    position: relative;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-radius: 2px;
    box-shadow: 0 4px rgba(0, 0, 0, 0.15);
    pointer-events: auto;
    max-width: 800px;
    display: inline-block;
}
</style>